import { CardCategoriesConfig } from '../../../shared/types/CardCategories/CardCategoriesConfig';

import { isManufacturerCardTypeEnabled } from './isManufacturerCardTypeEnabled';

export const shouldRenderReadOnlyManufacturerCard = (
  isLegacyManufacturerCard: boolean,
  cardCategoriesConfigObject: CardCategoriesConfig,
  medication?: string,
) => {
  return (
    (isLegacyManufacturerCard &&
      !isManufacturerCardTypeEnabled(
        cardCategoriesConfigObject,
      )) ||
    !!medication
  );
};
